module.exports = __webpack_public_path__ + "img/HQ-Z7100-V1.0294ef0f.jpg";